import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "Federal Employee Insurance Verification | Neuro Wellness TMS Centers of America",
  description:
    "Federal employees: submit your insurance information and our team will verify your FEHB or PSHB benefits for TMS, SAINT, and depression treatment.",
  canonical: "/federal-employee-insurance-verification",
  keywords:
    "federal employee insurance verification, FEHB benefits verification, federal employee TMS verification, verify FEHB mental health benefits",
};

const relatedLinks = [
  { title: "Federal Employee Hub", href: "/federal-employee-mental-health" },
  { title: "FEHB TMS Coverage", href: "/fehb-tms-coverage" },
  { title: "How Insurance Works", href: "/how-insurance-works" },
  { title: "Cost & Insurance", href: "/cost-insurance" },
];

export default function FederalEmployeeInsuranceVerification() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Insurance Verification"
      title="Federal Employee Insurance Verification"
      subtitle="Submit your FEHB or PSHB plan information and our team will verify what treatment options may be available through your specific plan."
    >
      <DecisionSection heading="How verification works">
        <p>
          Verifying benefits and obtaining authorization are different
          processes. Here's the sequence:
        </p>
        <DecisionList
          items={[
            "You submit your insurance information through our form or by phone",
            "Our team contacts your carrier to verify your behavioral health benefits",
            "We identify whether TMS, SAINT, or other treatments may be covered under your plan",
            "We gather clinical documentation and submit a prior authorization request if needed",
            "We notify you of the decision and explain your out-of-pocket costs before any treatment",
            "If denied, we file an appeal with additional documentation on your behalf",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="What to prepare">
        <p>To make verification faster, have the following ready:</p>
        <DecisionList
          items={[
            "Your insurance card (front and back)",
            "A list of antidepressants you've tried, including approximate dates and why you stopped",
            "Your current prescriber's name and contact information",
            "Any prior TMS treatment records, if applicable",
            "A note from your therapist or psychiatrist, if available",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="What we handle">
        <p>
          You don't need to call your insurer yourself. Our team handles the
          entire process — benefits verification, documentation gathering,
          authorization submission, and appeals. We'll give you a clear answer
          about what your plan covers and what your costs may be, in writing,
          before you commit to anything.
        </p>
      </DecisionSection>

      <DecisionSection heading="Start now">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          to speak with our team, or complete the insurance verification form on
          our{" "}
          <Link to="/cost-insurance" className="text-accent hover:underline">
            cost and insurance page
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
